module.exports = __webpack_public_path__ + "media/images/subject_img/LIBERAL ARTS-87db7c27b1bf42592d4ccdf00f44e459.jpg";